export const getAllMovies = async ({genreId, pageNumber}) => {
    try {
        const response = await fetch(`https://api.themoviedb.org/3/discover/movie?api_key=9126dfb75a74e201f9b78fd7c7dde868&with_genres=${genreId}&page=${pageNumber}`);
        return response.json();
    } catch (error) {
        console.log(`HHP: ${error}`);
        throw new Error(genreId);
    }
}

export const getAllTvSeries = async ({genreId, pageNumber}) => {
    try {
        const response = await fetch(`https://api.themoviedb.org/3/discover/tv?api_key=9126dfb75a74e201f9b78fd7c7dde868&with_genres=${genreId}&page=${pageNumber}`);
        return response.json();
    } catch (error) {
        console.log(`HHP: ${error}`);
        throw new Error(genreId);
    }
}

export const getItem = async ({itemId, type}) => {
    try {
        const response = await fetch(`https://api.themoviedb.org/3/${type}/${itemId}?api_key=9126dfb75a74e201f9b78fd7c7dde868`);
        return response.json();
    } catch (error) {
        console.log(`HHP: ${error}`);
        throw new Error(itemId);
    }
}

export const getCast = async ({itemId, type}) => {
    try {
        const response = await fetch(`https://api.themoviedb.org/3/${type}/${itemId}/credits?api_key=9126dfb75a74e201f9b78fd7c7dde868`);
        return response.json();
    } catch (error) {
        console.log(`HHP: ${error}`);
        throw new Error(itemId);
    }
}

export const getCastDetails = async (castId) => {
    try {
        const response = await fetch(`https://api.themoviedb.org/3/person/${castId}?api_key=9126dfb75a74e201f9b78fd7c7dde868`);
        return response.json();
    } catch (error) {
        console.log(`HHP: ${error}`);
        throw new Error(castId);
    }
}

export const getProductionDetails = async (productionId) => {
    try {
        const response = await fetch(`https://api.themoviedb.org/3/company/${productionId}?api_key=9126dfb75a74e201f9b78fd7c7dde868`);
        return response.json();
    } catch (error) {
        console.log(`HHP: ${error}`);
        throw new Error(productionId);
    }
}

export const getSeasonDetails = async ({seriesId, seasonNum}) => {
    try {
        const response = await fetch(`https://api.themoviedb.org/3/tv/${seriesId}/season/${seasonNum}?api_key=9126dfb75a74e201f9b78fd7c7dde868`);
        return response.json();
    } catch (error) {
        console.log(`HHP: ${error}`);
        throw new Error(seriesId);
    }
}

export const getSimilarItems = async ({type, itemId, genreId, language}) => {
    try {
        const response = await fetch(`https://api.themoviedb.org/3/${type}/${itemId}/similar?api_key=9126dfb75a74e201f9b78fd7c7dde868&with_genres=${genreId}`);
        return response.json();
    } catch (error) {
        console.log(`HHP: ${error}`);
        throw new Error(itemId);
    }
}